const StarRating = ({ count = 5 }) => (
  <div style={{ display: "flex", gap: "2px", margin: "6px 0 10px" }}>
    {Array.from({ length: 5 }).map((_, i) => (
      <svg
        key={i}
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill={i < count ? "#fbbc04" : "#e0e0e0"}
      >
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    ))}
  </div>
);

const getInitials = (name) => (name ? name.charAt(0).toUpperCase() : "");

const avatarColors = [
  "#4285F4", "#EA4335", "#FBBC05", "#34A853",
  "#FF6D00", "#9C27B0", "#00BCD4", "#F06292",
];

const TestimonialCard = ({ d, index }) => {
  const initials = getInitials(d.name);
  const bgColor = avatarColors[index % avatarColors.length];
  // Strip surrounding quotes if present
  const text = d.text.replace(/^"+|"+$/g, "");

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "20px 24px",
        width: "300px",
        minWidth: "300px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
        border: "1px solid #e8eaed",
        display: "flex",
        flexDirection: "column",
        margin: "0 12px",
        userSelect: "none",
      }}
    >
      {/* Header: avatar + name + Google logo */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "50%",
              background: bgColor,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "700",
              fontSize: "20px",
              fontFamily: "sans-serif",
            }}
          >
            {initials}
          </div>
          <div>
            <div style={{ fontWeight: "600", fontSize: "14px", color: "#202124" }}>
              {d.name}
            </div>
            <div style={{ fontSize: "12px", color: "#70757a" }}>Google-vélemény</div>
          </div>
        </div>
        {/* Google "G" logo */}
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
        </svg>
      </div>

      {/* Stars */}
      <StarRating count={5} />

      {/* Review text */}
      <p
        style={{
          fontSize: "13.5px",
          color: "#3c4043",
          lineHeight: "1.6",
          margin: 0,
          display: "-webkit-box",
          WebkitLineClamp: 4,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {text}
      </p>
    </div>
  );
};

export const Testimonials = (props) => {
  const data = props.data || [];
  // Duplicate for seamless infinite loop
  const doubled = [...data, ...data];

  return (
    <section id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>Mit mondanak a klienseim</h2>
        </div>
      </div>

      {/* Full-width marquee strip */}
      <div
        style={{
          overflow: "hidden",
          padding: "12px 0 32px",
          position: "relative",
        }}
      >
        {/* Fade edges */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "120px",
            height: "100%",
            background: "linear-gradient(to right, #f6f6f6, transparent)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "120px",
            height: "100%",
            background: "linear-gradient(to left, #f6f6f6, transparent)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        />

        <div className="testimonials-track">
          {doubled.map((d, i) => (
            <TestimonialCard key={i} d={d} index={i % data.length} />
          ))}
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: "20px", paddingBottom: "30px" }}>
        <a
          href="https://www.google.com/search?q=Ga%C3%A1l+Garage+Ny%C3%ADregyh%C3%A1za+v%C3%A9lem%C3%A9nyek"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="btn btn-custom btn-lg">
            Összes Google vélemény
          </button>
        </a>
      </div>
    </section>
  );
};
